<div class="main-table">
    <div class="main-table-toolbar">
        <div class="main-toolbar-container">
            <div class="main-toolbar-add">
                <pixl-type-cb
                    [matLabelText]="'Übungsaufgaben' | transloco"
                    [matIcon]="'add'"
                    [resetOnSelect]="true"
                    (onStateChange)="addExercise($event)"
                />
            </div>
            <div class="main-toolbar-spacer"></div>
            <div class="main-toolbar-filter-container">
                <div class="main-toolbar-filter">
                    <div class="filter-item">
                        <pixl-free-filter-input
                            [label]="'Name'"
                            [matIcon]="'search'"
                            [hint]="getSearchFilterHint()"
                            [minLength]="freeFilterLen"
                            (onKeyUpChange)="setFreeFilter($event)"
                        />
                    </div>

                    <div class="filter-item">
                        <mat-form-field>
                            <mat-label>Konsumenten</mat-label>
                            <mat-select multiple (valueChange)="setConsumerFilter($event)">
                                @for (consumer of consumers$ | async; track consumer) {
                                    <mat-option [value]="consumer.id">{{consumer.name}}</mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                    </div>

                    <div class="filter-item">
                        <mat-form-field>
                            <mat-label>Fächer</mat-label>
                            <mat-select multiple (valueChange)="setSubjectFilter($event)">
                                @for (subject of subjects$ | async; track subject) {
                                    <mat-option [value]="subject.treeId">{{subject.name}}</mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                    </div>

                    <div class="filter-item">
                        <pixl-state-cb
                            (onStateChange)="setStatusFilter($event)"
                            [withEmptyOption]="true"
                        />
                    </div>

                    <div class="filter-item">
                        <pixl-type-cb
                            (onStateChange)="setKindFilter($event)"
                            matLabelText="Typ"
                        />
                    </div>
                </div>
                <div class="main-toolbar-spacer-right"></div>
            </div>
            <div class="table-header-overlay"></div>
        </div>
    </div>

    <div class="table-container mat-elevation-z4">
        @if (exercises$ | async; as exercises) {
            <table mat-table [dataSource]="exercises" matSort (matSortChange)="announceSortChange($event)">
                <ng-container matColumnDef="edit-actions">
                    <th
                        mat-header-cell
                        *matHeaderCellDef
                    >{{ "actions" | transloco }}</th>
                    <td
                        mat-cell
                        *matCellDef="let exercise"
                    >
                        <button
                            [class.btn-success]="coloredButtonsEnabled()"
                            mat-icon-button
                            aria-label="Edit"
                            (click)="editExercise(exercise)"
                            [disabled]="!exercise.consumerId"
                            matTooltip="{{ 'edit_meta_data_hint' | transloco }}"
                        >
                            <mat-icon>edit</mat-icon>
                        </button>
                        <button
                            [class.btn-warning]="coloredButtonsEnabled()"
                            mat-icon-button
                            aria-label="Edit"
                            (click)="editContentExercise(exercise)"
                            matTooltip="{{ 'edit_content_hint' | transloco }}"
                        >
                            <mat-icon>draw</mat-icon>
                        </button>
                        <button
                            [class.btn-info]="coloredButtonsEnabled()"
                            mat-icon-button
                            aria-label="Edit"
                            (click)="copyExercise(exercise)"
                            matTooltip="{{ 'copy_record_hint' | transloco }}"
                        >
                            <mat-icon>content_copy</mat-icon>
                        </button>
                        <button
                            [class.btn-danger]="coloredButtonsEnabled()"
                            mat-icon-button
                            aria-label="Delete"
                            matTooltip="Datensatz l&ouml;schen"
                            (click)="deleteExercise(exercise)"
                        >
                            <mat-icon>delete</mat-icon>
                        </button>
                        <button
                            [class.btn-primary]="coloredButtonsEnabled()"
                            mat-icon-button
                            aria-label="Delete"
                            matTooltip="Vorschau"
                            (click)="previewPlayer2(exercise)"
                        >
                            <mat-icon>visibility</mat-icon>
                        </button>
                    </td>
                </ng-container>

                <ng-container matColumnDef="id">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>ID</th>
                    <td mat-cell *matCellDef="let exercise">{{ exercise.id }}</td>
                </ng-container>

                <ng-container matColumnDef="kind">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "type" | transloco }}</th>
                    <td mat-cell *matCellDef="let exercise">
                        <pixl-lang [key]="exercise.kind" [keySuffix]="exercise.config?.exerciseSubKind?.toString()"></pixl-lang>
                    </td>
                    <td mat-cell *matCellDef="let exercise">
                        <pixl-lang [key]="exercise.kind" [keySuffix]="exercise.config?.exerciseSubKind?.toString()"></pixl-lang>
                    </td>
                </ng-container>

                <ng-container matColumnDef="name">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "name" | transloco }}</th>
                    <td mat-cell *matCellDef="let exercise">{{ exercise.name }}</td>
                </ng-container>

                <ng-container matColumnDef="consumer">
                    <th mat-header-cell *matHeaderCellDef>{{ "application" | transloco }}</th>
                    <td mat-cell *matCellDef="let exercise">
                        @if (exercise.consumers) {
                        {{ getConsumer(exercise.consumers.id, true) }}
                        } @else {
                        ---
                        }
                    </td>
                </ng-container>

                <ng-container matColumnDef="competency">
                    <th mat-header-cell *matHeaderCellDef>{{ "subject" | transloco }}</th>
                    <td mat-cell *matCellDef="let exercise">
                        @if (exercise.subjects) {
                        {{ getSubject(exercise.subjects.id, true) }}
                        } @else {
                        ---
                        }
                    </td>
                </ng-container>

                <ng-container matColumnDef="updated">
                    <th mat-header-cell *matHeaderCellDef>{{ "created" | transloco }}</th>
                    <td mat-cell *matCellDef="let exercise">
                        {{ getCreatedDate(exercise.id) | date }}
                    </td>
                </ng-container>

                <ng-container matColumnDef="approval">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "state" | transloco }}</th>
                    <td mat-cell *matCellDef="let exercise">
                        <div class="editstate" #editStateDiv>
                            <button class="badge" [ngClass]="getStatusColor(exercise.approval)" (click)="changeExerciseState(exercise)">
                                {{ getStateText(exercise.approval) }}
                            </button>
                        </div>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                <tr
                    mat-row
                    *matRowDef="let row; columns: displayedColumns"
                    (dblclick)="editExercise(row)"
                    [class.selected-row]="currentSelectedRow() === row.id"
                ></tr>
            </table>
        } @else {
            <pixl-table-loading-spinner [name]="'Übungsaufgaben'" />
        }
        <mat-paginator [length]="totalItems || 0" [pageSize]="pageSize" [pageSizeOptions]="[5, 10, 20]"></mat-paginator>
    </div>
</div>